export const NOTIFICATION_API_URL = {
  NOTIFICATION_REPLACER: 'noti-replacer-field',
  NOTIFICATION_MATER_TEMPLATE: 'master-template',
  NOTIFICATION_TEMPLATE: 'noti-template',
  MODULE_ACTIVITY: 'noti-module-activity',
  ACTIVITY_MAP: 'noti-activity-map',
};
